<ng-container *transloco="let t">
  @if (viewMode === ViewTypeEnum.LIST) {
    <div
      class="group relative flex items-center bg-white p-3 duration-100"
      [ngClass]="{ 'hover:bg-gray-50': _isSelectable }"
      [class.disabled]="_disabled"
      [class.list-separator]="!isLast"
      (click)="toggleAsin()"
    >
      @if (product(); as product) {
        @if (_isSelectable) {
          <ICheckbox
            [value]="_selected"
            (valueChange)="toggleAsin()"
            (click)="$event.stopPropagation()"
            [disabled]="isReadOnly"
            testid="checkbox-asin-item"
          />
        }
        <app-product-thumbnail class="sensitive-data mx-2" [product]="product" [smallImg]="true" />
        <div class="min-w-0 truncate">
          <div
            class="sensitive-data truncate font-medium text-gray-800"
            [iTooltip]="product.title"
            data-testid="asin-item-title"
          >
            {{ product.title }}
          </div>
          <div class="sensitive-data flex items-center">
            <IBadge class="mr-2" color="gray" [label]="product.asin" />
            @if (product.brand) {
              <IBadge color="gray" [label]="product.brand" />
            }
            @if (_activeStrategies() && _activeStrategies()!.length > 0) {
              <span
                class="text-main-500 ml-3"
                (mouseenter)="displayActiveStrategies(trigger)"
                (mouseleave)="hideActiveStrategies()"
                type="button"
                cdkOverlayOrigin
                #trigger="cdkOverlayOrigin"
                style="font-weight: 500"
                >{{ activeStrategiesMessage() }}</span
              >
            }
            @if (isIneligible) {
              <IIcon name="alertTriangle" class="ml-2 text-xl text-orange-400" />
            }
            @if (isPaused) {
              <IIcon name="pauseCircle" class="ml-2 text-xl text-gray-300" />
            }
            @if (actionsButtons) {
              <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            }
          </div>
        </div>
      } @else {
        <ISpinner [display]="true" />
      }
    </div>
  } @else {
    <div iCard [class]="cardStyle" (click)="toggleAsin()">
      <div iCardContent>
        @if (product(); as product) {
          @if (_selected) {
            <IIcon name="checkCircle" class="text-main-500 absolute top-1 left-1 text-xl" />
          }
          @if (actionsButtons) {
            <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
          }
          <div class="relative flex gap-3">
            <div class="relative flex rounded-xs border border-gray-200 p-1">
              <app-product-thumbnail [product]="product" customSizeClass="size-16" class="sensitive-data" />

              @if (isIneligible) {
                <IIcon name="alertTriangle" class="absolute top-0 right-0 -mt-3 -mr-1 text-xl text-orange-400" />
              }
              @if (isPaused) {
                <IIcon name="pauseCircle" class="absolute top-0 right-0 -mt-3 -mr-1 text-xl text-gray-300" />
              }
            </div>

            <div class="sensitive-data flex flex-col gap-1 truncate">
              @if (_activeStrategies() && _activeStrategies()!.length > 0) {
                <span
                  class="text-main text-sm font-medium select-none"
                  (mouseenter)="displayActiveStrategies(trigger)"
                  (mouseleave)="hideActiveStrategies()"
                  type="button"
                  cdkOverlayOrigin
                  #trigger="cdkOverlayOrigin"
                >
                  {{ activeStrategiesMessage() }}
                </span>
              }
              <span class="truncate text-sm font-medium" [iTooltip]="product.title" iTooltipPlacement="bottom">{{
                product.title
              }}</span>
              <div class="flex w-full">
                <IBadge color="gray" [label]="product.asin" class="mr-2" />

                @if (product.brand) {
                  <IBadge color="gray" [label]="product.brand" />
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="flex animate-pulse">
            <div class="h-16 w-16 rounded-xs bg-slate-200"></div>
            <div class="ml-2">
              <div class="mb-3 h-4 w-28 rounded-sm bg-slate-200"></div>
              <div class="h-4 w-40 rounded-sm bg-slate-200"></div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="activeStrategiesOrigin!"
    [cdkConnectedOverlayOpen]="overlayOpened"
  >
    <div class="card-common p-2" #activeStrategiesPopup>
      @for (s of _activeStrategies(); track s.strategyId) {
        <div class="flex w-full items-center justify-between" [class.mb-2]="!$last">
          <div>
            <app-strategy-state [state]="s.state" class="mr-2 inline-flex"></app-strategy-state>
            <span>{{ s.name }}</span>
          </div>
          <IBadge class="ml-2" color="gray" [label]="StrategyTypeStr[s.strategyType]" size="xs" />
        </div>
      }
    </div>
  </ng-template>

  <ng-template #actionButtons>
    <div class="absolute top-0 right-0 z-50 mt-3 mr-3 opacity-0 group-hover:opacity-100">
      <button
        iButton
        variant="secondary"
        size="xs"
        class="mr-1"
        [iTooltip]="t('common.copy_asin')"
        (click)="copyToClipboard(product()?.asin); $event.stopPropagation()"
      >
        <IIcon name="copyO" />
      </button>

      <a
        iButton
        variant="secondary"
        size="xs"
        routerLink="/product-center/product360"
        [queryParams]="{ asin: product()?.asin }"
        target="_blank"
        queryParamsHandling="merge"
        [iTooltip]="t('parent-product-view-widget.view_in_product_360')"
        (click)="$event.stopPropagation()"
      >
        <IIcon name="binoculars" />
      </a>
    </div>
  </ng-template>
</ng-container>
